import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
  Typography,
} from "@suraasa/placebo-ui"
import { LearningItem } from "api/resources/learningItems/types"
import HandHoldingPen from "assets/Fallback/hand-holding-pen.svg"
import clsx from "clsx"
import Fallback from "components/Fallback"
import { IMPACT_COURSE_TOUR_TARGETS } from "features/Home/SuraasaPlusNewYearOnboarding/ImpactCourseTour/constants"
import { NavArrowDown } from "iconoir-react"
import groupBy from "lodash/groupBy"
import { learningItemSlugs } from "utils/constants"

import MilestoneItem from "./MilestoneItem"

type Props = {
  plannerId: number
  className?: string
  data: LearningItem[] | undefined
  isError: boolean
  isLoading: boolean
  slug: string
}

const Curriculum = ({
  className,
  plannerId,
  data,
  isError,
  isLoading,
  slug,
}: Props) => {
  if (isError || isLoading || !data || data.length === 0) {
    let title = "Something is not right"
    if (data?.length === 0) title = "Your course curriculum is not defined yet."
    if (isError) title = "Something went wrong"

    return (
      <div className={clsx(className)}>
        <Typography variant="title3" className="mb-1">
          Learning
        </Typography>
        <Fallback
          data={{
            image: HandHoldingPen,
            title: title,
            description: "Please contact care@suraasa.com",
          }}
          hasError={isError}
          isLoading={isLoading}
          className="mb-3 mt-9 sm:mt-20 md:mt-18"
        />
      </div>
    )
  }
  const milestones = groupBy(data, "milestone.id")

  const totalMilestones = Object.keys(milestones).length

  return (
    <div
      className={clsx(className, {
        [IMPACT_COURSE_TOUR_TARGETS.courseTour.milestoneList]:
          slug === learningItemSlugs.impactCourse,
      })}
    >
      <Typography variant="title3" className="mb-1">
        Learning
      </Typography>
      {Object.entries(milestones).map(([milestoneId, milestone], index) => {
        const isLast = index === totalMilestones - 1

        return (
          <div
            key={milestoneId}
            className={clsx(
              "border-2 border-surface-200 bg-white px-0 py-2 sm:px-1",
              {
                "rounded-t-2xl": index === 0,
                "border-b-0": totalMilestones > 1 && !isLast,
                "rounded-b-2xl": isLast,
              }
            )}
          >
            <Accordion type="single">
              <AccordionItem value={milestoneId}>
                <AccordionTrigger icon={<NavArrowDown color="black" />}>
                  <Typography className="text-end" variant="strong">
                    Milestone {index + 1}
                  </Typography>
                </AccordionTrigger>
                <AccordionContent className="mt-2">
                  {milestone.map((item, index) => (
                    <div
                      key={index}
                      className={clsx({
                        "mb-2": index < milestone.length - 1,
                      })}
                    >
                      <MilestoneItem item={item} plannerId={plannerId} />
                    </div>
                  ))}
                </AccordionContent>
              </AccordionItem>
            </Accordion>
          </div>
        )
      })}
    </div>
  )
}

export default Curriculum
